export default __webpack_public_path__ + "i18n/translations/translation-ja.219e3d8e.json";